import { NhisStatus } from "types/nhis";

export interface NhisStatusConfig {
  label: string;
  description: string;
  tagColor: "Blue" | "Green" | "Red" | "Gray" | "Orange";
  tagVariant: "Tinted" | "Contained";
  icon: string;
}

export const STATUS_CONFIG: Record<NhisStatus, NhisStatusConfig> = {
  PENDING: {
    label: "진행 중",
    description: "환자에게 요청을 보냈습니다",
    tagColor: "Blue",
    tagVariant: "Tinted",
    icon: "Clock",
  },
  AUTH_REQUESTED: {
    label: "진행 중",
    description: "환자가 심평원 본인인증을 진행 중입니다",
    tagColor: "Blue",
    tagVariant: "Tinted",
    icon: "ID Card",
  },
  FETCHED: {
    label: "진행 중",
    description: "환자가 전달할 처방전을 선택하고 있습니다",
    tagColor: "Blue",
    tagVariant: "Tinted",
    icon: "Document",
  },
  DELIVERED: {
    label: "전달 완료",
    description: "처방전 정보가 저장되었습니다",
    tagColor: "Green",
    tagVariant: "Contained",
    icon: "Check Circle",
  },
  FAILED: {
    label: "실패",
    description: "요청이 실패했습니다",
    tagColor: "Red",
    tagVariant: "Tinted",
    icon: "Exclamation Mark Circle",
  },
  EXPIRED: {
    label: "만료",
    description: "요청이 만료되었습니다",
    tagColor: "Gray",
    tagVariant: "Tinted",
    icon: "Clock X",
  },
  CANCELLED: {
    label: "취소됨",
    description: "약사가 요청을 취소했습니다",
    tagColor: "Gray",
    tagVariant: "Tinted",
    icon: "X",
  },
};

export const ACTIVE_STATUSES: NhisStatus[] = ["PENDING", "AUTH_REQUESTED", "FETCHED"];
export const CANCELLABLE_STATUSES: NhisStatus[] = [
  "PENDING",
  "AUTH_REQUESTED",
  "FETCHED",
  "FAILED",
];
